export default {
    // GLOBAL
    globalOS: null,
    globalPhonesModels: null,

    // DONATION PAGE
    donationPageOS: null,

}
